module.exports = __webpack_public_path__ + "img/shiba-loading.f0236ff2.png";